import { render, staticRenderFns } from "./CmpnOpTableTab.vue?vue&type=template&id=3b134cc3&"
import script from "./CmpnOpTableTab.vue?vue&type=script&lang=js&"
export * from "./CmpnOpTableTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports